import PropTypes from 'prop-types'
import React from 'react'

export const Page = ({children, className}) => (<section className={className || 'main-content'}>{children}</section>)

Page.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
}
